import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=55e8212b&scoped=true"
import script from "./UserGrid.vue?vue&type=script&lang=js"
export * from "./UserGrid.vue?vue&type=script&lang=js"
import style0 from "./UserGrid.vue?vue&type=style&index=0&id=55e8212b&prod&scoped=true&lang=css"
import style1 from "./UserGrid.vue?vue&type=style&index=1&id=55e8212b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e8212b",
  null
  
)

export default component.exports